import { jsxs as c, jsx as a } from "react/jsx-runtime";
import { useState as f, useEffect as m } from "react";
import { T as A, b as l, c as O, d as E, e as _, a as h } from "./toast-BRKBR_c0.js";
const D = 1, I = 1e6;
let u = 0;
function M() {
  return u = (u + 1) % Number.MAX_SAFE_INTEGER, u.toString();
}
const d = /* @__PURE__ */ new Map(), S = (t) => {
  if (d.has(t))
    return;
  const s = setTimeout(() => {
    d.delete(t), n({
      type: "REMOVE_TOAST",
      toastId: t
    });
  }, I);
  d.set(t, s);
}, y = (t, s) => {
  switch (s.type) {
    case "ADD_TOAST":
      return {
        ...t,
        toasts: [s.toast, ...t.toasts].slice(0, D)
      };
    case "UPDATE_TOAST":
      return {
        ...t,
        toasts: t.toasts.map((e) => e.id === s.toast.id ? { ...e, ...s.toast } : e)
      };
    case "DISMISS_TOAST": {
      const { toastId: e } = s;
      return e ? S(e) : t.toasts.forEach((o) => {
        S(o.id);
      }), {
        ...t,
        toasts: t.toasts.map(
          (o) => o.id === e || e === void 0 ? {
            ...o,
            open: !1
          } : o
        )
      };
    }
    case "REMOVE_TOAST":
      return s.toastId === void 0 ? {
        ...t,
        toasts: []
      } : {
        ...t,
        toasts: t.toasts.filter((e) => e.id !== s.toastId)
      };
  }
}, i = [];
let T = { toasts: [] };
function n(t) {
  T = y(T, t), i.forEach((s) => {
    s(T);
  });
}
function g({ ...t }) {
  const s = M(), e = (r) => n({
    type: "UPDATE_TOAST",
    toast: { ...r, id: s }
  }), o = () => n({ type: "DISMISS_TOAST", toastId: s });
  return n({
    type: "ADD_TOAST",
    toast: {
      ...t,
      id: s,
      open: !0,
      onOpenChange: (r) => {
        r || o();
      }
    }
  }), {
    id: s,
    dismiss: o,
    update: e
  };
}
function v() {
  const [t, s] = f(T);
  return m(() => (i.push(s), () => {
    const e = i.indexOf(s);
    e > -1 && i.splice(e, 1);
  }), [t]), {
    ...t,
    toast: g,
    dismiss: (e) => n({ type: "DISMISS_TOAST", toastId: e })
  };
}
function w() {
  const { toasts: t } = v();
  return /* @__PURE__ */ c(A, { children: [
    t.map(function({ id: s, title: e, description: o, action: r, ...p }) {
      return /* @__PURE__ */ c(l, { ...p, children: [
        /* @__PURE__ */ c("div", { className: "grid gap-1", children: [
          e && /* @__PURE__ */ a(O, { children: e }),
          o && /* @__PURE__ */ a(E, { children: o })
        ] }),
        r,
        /* @__PURE__ */ a(_, {})
      ] }, s);
    }),
    /* @__PURE__ */ a(h, {})
  ] });
}
export {
  w as T,
  y as r,
  g as t,
  v as u
};
//# sourceMappingURL=toaster-CDNONV0r.js.map
